/**
 * A button that can be working.
 *
 * Every action here talks to a server that is sometimes slow — drawing a picture takes the better
 * part of a minute — and a button that only greys out says "not now" rather than "doing it". The
 * spinner sits where it was pressed, so nobody has to hunt the screen for proof that something is
 * happening, and the label stays put so the row does not jump.
 */
export default function Button({
  loading = false,
  disabled = false,
  className = 'button',
  children,
  ...rest
}) {
  return (
    <button
      {...rest}
      className={`${className}${loading ? ' is-loading' : ''}`}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
    >
      {loading && <span className="spinner" aria-hidden="true" />}
      <span className="button__label">{children}</span>
    </button>
  )
}
